import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { catchError } from 'rxjs/operators';
import { Observable, of, throwError } from 'rxjs';
import { baseAPI } from '../endpoint';
import { GlobalEventsManager } from '../global-events-manager';

@Injectable({
  providedIn: 'root'
})

export class FeedbackService {

  private reportFeedbackAPI = `${baseAPI}/reporting/feedback`;
  private reportFeedbackImagesAPI = `${baseAPI}/reporting/feedbackImages`;

  constructor(
    private http: HttpClient,
    private globalEventsManager: GlobalEventsManager
  ) { }

  reportFeedback(feedbackType: String | Number, comments?: String | null): Observable<any> {
    const postData = {
      token: localStorage.getItem('token'),
      internalOrExternal: 'internal',
      title: 'Theme Change',
      application: 'Insync Internal',
      comments,
      feedbackType,
      timeCreated: new Date()
    };

    return this.http.post<Number>(this.reportFeedbackAPI, postData)
    .pipe(catchError(this.handleError()));
  }

  reportCancelledFeedback(): Observable<any> {
    const postData = {
      token: localStorage.getItem('token'),
      internalOrExternal: 'internal',
      title: 'Theme Change',
      application: 'Insync Internal',
      comments: null,
      feedbackType: 0,
      timeCreated: new Date()
    };

    return this.http.post<Number>(this.reportFeedbackAPI, postData)
    .pipe(catchError(this.handleError()));
  }

  reportFeedbackImages(id: Number, files: File[]): Observable<any> {
    const formData = new FormData();

    formData.append('feedbackID', id.toString());
    formData.append('token', localStorage.getItem('token'));
    formData.append('internalOrExternal', 'internal');
    files.forEach(file => {
      formData.append('files', file, file.name);
    });

    return this.http.post<any>(this.reportFeedbackImagesAPI, formData, {
      reportProgress: true,
      observe: 'events'
    })
    .pipe(catchError(this.handleError()));
  }

  private handleError<T> () {
    return (error: any): Observable<T> => {
      console.error(error);

      if (!error.status) {
        return throwError('Connection Error');
      }

      if (error.error && error.error.text === 'expire') {
        this.globalEventsManager.logout(true);
        return throwError(error.error.text);
      }

      return throwError(error.error);
    };
  }

}
